import { Box } from "@mui/material";

export default function DeactiveStepIcon() {
    return (
        <Box sx={{ width: { xs: "21px", md: "47px" } }}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 47 47"
                fill="none"
            >
                <circle
                    id="Ellipse 3"
                    cx="23.5"
                    cy="23.5"
                    r="23"
                    fill="white"
                    stroke="black"
                />
            </svg>
        </Box>
    );
}
